import axios, { AxiosRequestConfig, ResponseType } from 'axios';
import { handleLogout } from '@commons/utils/hooks/authentication';

export const getStandardHeaders = (): { 'Content-Type': string; Authorization: string } => {
  const accessToken = localStorage.getItem('accessToken');

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };
};

const API_URL = import.meta.env.VITE_API_URL;
const baseUrl = `${API_URL}/api/v1/backoffice/`;

// Create an axios instance with interceptor
const axiosInstance = axios.create();

// Add response interceptor to handle 401/403 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if the error response is a 401 or a 403
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      handleLogout();
    }
    return Promise.reject(error);
  }
);

const apiGet = async (
  url: string,
  params: object = {},
  responseType: ResponseType = 'json',
  config: AxiosRequestConfig = {}
) => {
  const headers = getStandardHeaders();

  const { data } = await axiosInstance.get(`${baseUrl}${url}`, {
    params,
    headers,
    responseType,
    ...config
  });

  return data;
};

const apiPost = async (
  url: string,
  bodyParams: object = {},
  config: AxiosRequestConfig = {}
): Promise<unknown> => {
  const headers = getStandardHeaders();

  const { data } = await axiosInstance.post(
    `${baseUrl}${url}`,
    { ...bodyParams },
    { headers, responseType: 'json', ...config }
  );
  return data;
};

export const APIcaller = {
  apiGet,
  apiPost
  //   apiPut,
  //   apiPatch,
  //   apiDelete,
};
